import { Styles } from '@core-ui/radio/types/types';
import {
  CSSObject,
  forBrands,
  getFontWeight,
  Theme,
} from '@core-ui/react-stitch';

const setCustomRadioStylesForBananaRepublic = (theme: Theme,isBRcolor2023FFEnabled:boolean): CSSObject => ({
  labelText: {
    color: isBRcolor2023FFEnabled ? "#000000" : theme.color.b2,
  },
  radioButton: {
    borderColor: isBRcolor2023FFEnabled ? "#000000" : theme.color.b2,
  },
});

const setCustomRadioBackgroundStylesForBananaRepublic = (
  theme: Theme,isBRcolor2023FFEnabled:boolean
): string => isBRcolor2023FFEnabled ? "#000000" : theme.color.b2;

export const displayWrapperStyleForBananaRepublic = (isBRcolor2023FFEnabled?:boolean): CSSObject => ({
  label: {
    marginBottom: '1rem',
  },
  ...(isBRcolor2023FFEnabled && {

    label:{ 
      color : '#000000',
     '&:hover' : {
      textDecoration: 'underline',
      textDecorationColor:'#000000',
    }},
    'div[role="checkbox"]': {
      border: '0.0625rem solid #000000',
      '&::before': {
        backgroundColor: '#000000',
      },
    },
    'div[role="checkbox"] + div': {
      color: '#000000',
    },
  }),

});

export const displayWrapperStylesForAllBrands = () => ({
  label: {
    marginBottom: '1.5rem',
  },
});

const setDisplayItemStylesForBananaRepublic = (theme: Theme,isBRcolor2023FFEnabled:boolean): CSSObject => ({
  label: {
    color: isBRcolor2023FFEnabled ? "#000000" : theme.color.b2,
    fontWeight: getFontWeight('regular').fontWeight,
  },
});

export const displayItemStyle = (theme: Theme,isBRcolor2023FFEnabled:boolean): CSSObject => ({
  display: 'flex',
  justifyContent: 'center',
  width: '33%',
  marginBottom: '1rem',
  ...(forBrands(theme, {
    br: setDisplayItemStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
    brfs: setDisplayItemStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
  }) as CSSObject),
});

export const customBackgroundColorForRadio = (theme: Theme,isBRcolor2023FFEnabled:boolean) =>
  forBrands(theme, {
    br: setCustomRadioBackgroundStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
    brfs: setCustomRadioBackgroundStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
    default: () => '',
  }) as string;

export const customRadioStyles = (theme: Theme,isBRcolor2023FFEnabled:boolean) =>
  forBrands(theme, {
    br: setCustomRadioStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
    brfs: setCustomRadioStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
  }) as Styles;

